import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Leaderboard banner above the beats grid (970x90 style).
 * Single slot. Hides if no active ad.
 */
const BeatsHeaderAd = () => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/api/ads/active`)
      .then((res) => {
        if (cancelled) return;
        const list = (res.data && res.data.beats_header) || [];
        if (list.length > 0) setAd(list[0]);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ad) return null;

  return (
    <a
      href={ad.destination_url || '#'}
      target="_blank"
      rel="noopener sponsored noreferrer"
      data-testid="beats-header-ad"
      className="block max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6"
      aria-label={`Sponsored: ${ad.brand_name}`}
    >
      <div className="relative overflow-hidden rounded-md border border-[#262626] hover:border-[#D4AF37]/50 transition-all flex items-center bg-[#0F0F0F]">
        <span className="absolute top-2 left-2 text-[9px] tracking-[0.2em] uppercase text-white/70 bg-black/60 px-1.5 py-0.5 rounded">
          Sponsored
        </span>
        {ad.ad_image_url ? (
          <img
            src={ad.ad_image_url}
            alt={ad.brand_name}
            className="w-full h-[90px] object-cover"
          />
        ) : (
          <div className="w-full h-[90px] bg-gradient-to-r from-[#1A1A1A] to-[#262626] flex items-center justify-center">
            <span className="text-xl text-[#D4AF37] font-['Bebas_Neue'] tracking-wider">
              {ad.brand_name}
            </span>
          </div>
        )}
        <span className="absolute bottom-2 right-3 text-xs text-[#D4AF37] flex items-center gap-2">
          {ad.headline && <span className="text-white/80 hidden sm:inline">{ad.headline}</span>}
          <span>{ad.cta_text || 'Visit'} &rarr;</span>
        </span>
      </div>
    </a>
  );
};

export default BeatsHeaderAd;
